import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { IQueryInvoker, QUERY_INVOKER, Tlob } from "@ebootis/common";

@Injectable({providedIn: 'root'})
export class ArticleDetailsByOid
{
	constructor(@Inject(QUERY_INVOKER) private m_queryInvoker: IQueryInvoker) { }
	query(params: ArticleDetailsByOid.Params): Observable<ArticleDetailsByOid.Result>
	{
		return this.m_queryInvoker.doQuery("ArticleDetailsByOid", params);
	}
};

export namespace ArticleDetailsByOid
{
	export class Params
	{
		article: string;
		config: string;
	};
	export interface Result
	{
		salesAmountMin?: number;
		salesAmountMax?: number;
		onlyAvailableStock?: boolean;
		storagePackaging?: number;
		subPackaging?: number;
		currentStockLevel?: number;
		reservedStock?: number;
		availableNow?: number;
		unit?: string;
		freeContingent?: number;
		articleText?: ArticleText;
		oid?: string;
		proxyOid?: string;
		id?: string;
		descrShort?: string;
		logisticsAreaProxy?: LogisticsAreaProxy;
		descrLong?: string;
		isStockArticle?: boolean;
		primaryImage?: string;
		images?: Image[];
		ean?: string;
		attrCategory?: AttrCategory;
		attrArticleGroup?: AttrArticleGroup;
		attrDepartment?: AttrDepartment;
		attrInfo1?: AttrInfo1;
		attrInfo2?: AttrInfo2;
		attrInfo3?: AttrInfo3;
		attrInfo4?: AttrInfo4;
		attrInfo5?: AttrInfo5;
		attrInfo6?: AttrInfo6;
		backOrder?: number;
		lastIncomingDate?: Date;
		lastIncomingAmount?: number;
		lastOutgoingDate?: Date;
		lastOutgoingAmount?: number;
		verkaufspreis?: number;
		einkaufspreis?: number;
		customerPrice?: number;
		currencyCode?: string;
		stockUnit?: string;
		orderPoint?: number;
		replacementTime?: number;
		isVariantBase?: boolean;
		isVariant?: boolean;
		variantBaseOid?: string;
		variantDef?: VariantDef;
	};
	export interface ArticleText
	{
		text?: string;
	};
	export interface LogisticsAreaProxy
	{
		name?: string;
		descr?: string;
	};
	export interface Image
	{
		oid?: string;
	};
	export interface AttrCategory
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrArticleGroup
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrDepartment
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo1
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo2
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo3
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo4
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo5
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface AttrInfo6
	{
		formatted?: string;
		attributeName?: string;
	};
	export interface VariantDef
	{
		attributes?: Attribute[];
		variants?: Variant[];
	};
	export interface Attribute
	{
		clsAttributeOid?: string;
		clsAttributeName?: string;
		isMandatory?: boolean;
	};
	export interface Variant
	{
		articleOid?: string;
		values?: Value[];
	};
	export interface Value
	{
		attributeOid?: string;
		formatted?: string;
	};
};
